module.exports = __webpack_public_path__ + "static/media/perito_o.a9954759.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/perito_o.png
// module id = 1159
// module chunks = 0